import React from "react";
import { Link } from "react-router-dom";

const CredentialCard = ({ employee }) => {
  debugger
  const serverHost = `http://${window.location.hostname.includes('localhost') ? 'localhost:4000' : 'unioninformatica.org:4000'}`;
  const profileImage = employee?.credentialData?.credentialPhoto  ? serverHost+ employee?.credentialData?.credentialPhoto : 'https://icon-library.com/images/default-profile-icon/default-profile-icon-24.jpg';
  return (
    <>
    <div class="credencial">
    <div class="header-mobile">
    <h1 className="text-xl font-semibold">¡Hola, {employee.name.split(' ')[0]}!</h1>
    <Link to='/afiliado/edit-afiliado'  class="btn btn-light" >
  <i class="fas fa-edit"></i> Editar
</Link>
</div>

    <div class="credential-card"  >
      <div class="flex justify-between items-center">
        <div>
          <img src="https://unioninformatica.org/wp-content/uploads/2022/11/logoui2-768x119.png" alt="Informática Logo" reclass="logo" class="logo-ui"/>
        </div>
        <div>
          <img
            src={profileImage}
            alt="Profile"
            class="profile-image"
          />
        </div>
      </div>

      <div class="mt-2">
        <h2 class="text-xl font-bold text-gray-800 afiliado-name">
          {employee.name.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')}
        </h2>
        
        <div class="mt-2">
          <div class="flex-col">
            <span class="text-xs text-gray-500">Número de Afiliado</span>
            <span class="text-base font-semibold">{employee.credentialData.credentialNumber}</span>
          </div>
          
          <div class="flex-col mt-1">
            <span class="text-xs text-gray-500">Número de documento</span>
            <span class="text-base font-semibold">{employee.dni}</span>
          </div>

          <div class="flex-col mt-1 desktop-only">
            <span class="text-xs text-gray-500">CUIL</span>
            <span class="text-base font-semibold">{employee.cuil}</span>
          </div>
        </div>
      </div>

      <div class="mt-3">
        <div class="flex justify-between items-center">
          <span class=" font-semibold">Afiliado Titular</span>
          <svg class="qr-code" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
            <rect x="7" y="7" width="3" height="3"></rect>
            <rect x="14" y="7" width="3" height="3"></rect>
            <rect x="7" y="14" width="3" height="3"></rect>
          </svg>
        </div>

        <p class="text-xs text-gray-500 text-center mt-3">
          Esta credencial es personal e intransferible para uso exclusivo del afiliado y debe ser acompañada siempre con su DNI.
        </p>
      </div>
    </div>
    </div>
    </>
  );
};

export default CredentialCard;
